import { QueryClient } from "@tanstack/react-query";

// Серверное состояние (catalog, боты, прогоны…). Заменяет ручной кэш _dashData/allBots + botsTimer (app-pages.js).
// Авто-поллинг отключён (как в legacy после ui-pass: рефреш на вход страницы/кнопку, не таймером).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
  },
});
